import React, { useState } from 'react';
import Modal from '../../components/common/Modal';

const initialStudentLeaveForm = {
    studentName: "",
    className: "",
    section: "",
    rollNumber: "",
    fromDate: "",
    toDate: "",
    leaveStatus: "",
    reason: "",
};
const StudentsLeaveRequests = () => {
    const [showStudentModal, setShowStudentModal] = useState(false);
    const [studentEditId, setStudentEditId] = useState(null);
    const [studentLeaveForm, setStudentLeaveForm] = useState(initialStudentLeaveForm);

    const [studentLeaveData, setStudentLeaveData] = useState([
        {
            id: 1,
            curriculum: "SSC",
            studentName: "Rahul Kumar",
            className: "10th",
            section: "A",
            rollNumber: "101",
            fromDate: "2025-07-05",
            toDate: "2025-07-06",
            reason: "Fever",
            status: "Pending",
            addedDate: "2025-07-03 10:30:00",
        },
        {
            id: 2,
            curriculum: "CBSC",
            studentName: "Priya Sharma",
            className: "9th",
            section: "B",
            rollNumber: "205",
            fromDate: "2025-07-08",
            toDate: "2025-07-08",
            reason: "Family Function",
            status: "Approved",
            addedDate: "2025-07-02 09:00:00",
        },
    ]);

    const handleStudentLeaveChange = (e) => {
        const { name, value } = e.target;

        setStudentLeaveForm({
            ...studentLeaveForm,
            [name]: value,
        });
    };

    const handleStudentLeaveSubmit = (e) => {
        e.preventDefault();

        if (studentEditId) {
            setStudentLeaveData((prev) =>
                prev.map((item) =>
                    item.id === studentEditId
                        ? {
                            ...item,
                            studentName: studentLeaveForm.studentName,
                            className: studentLeaveForm.className,
                            section: studentLeaveForm.section,
                            rollNumber: studentLeaveForm.rollNumber,
                            fromDate: studentLeaveForm.fromDate,
                            toDate: studentLeaveForm.toDate,
                            reason: studentLeaveForm.reason,
                            status: studentLeaveForm.leaveStatus,
                        }
                        : item
                )
            );
        } else {
            const newLeave = {
                id: Date.now(),
                studentName: studentLeaveForm.studentName,
                className: studentLeaveForm.className,
                section: studentLeaveForm.section,
                rollNumber: studentLeaveForm.rollNumber,
                fromDate: studentLeaveForm.fromDate,
                toDate: studentLeaveForm.toDate,
                reason: studentLeaveForm.reason,
                status: studentLeaveForm.leaveStatus,
                addedDate: new Date().toLocaleString(),
            };

            setStudentLeaveData((prev) => [newLeave, ...prev]);
        }

        setStudentLeaveForm(initialStudentLeaveForm);
        setStudentEditId(null);
        setShowStudentModal(false);
    };

    const handleStudentEdit = (row) => {
        setStudentEditId(row.id);

        setStudentLeaveForm({
            studentName: row.studentName,
            className: row.className,
            section: row.section,
            rollNumber: row.rollNumber,
            fromDate: row.fromDate,
            toDate: row.toDate,
            leaveStatus: row.status,
            reason: row.reason,
        });

        setShowStudentModal(true);
    };

    const handleStudentDelete = (id) => {
        if (window.confirm("Delete this leave request?")) {
            setStudentLeaveData((prev) =>
                prev.filter((item) => item.id !== id)
            );
        }
    };

    return (
        <>
            <div className="card shadow-sm">

                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">Students Leave Requests</h4>

                    <button
                        className="btn-add"
                        onClick={() => {
                            setStudentEditId(null);
                            setStudentLeaveForm(initialStudentLeaveForm);
                            setShowStudentModal(true);
                        }}
                    >
                       <i className="bi bi-plus-lg me-1 fw-bold"></i> Add Student Leave
                    </button>
                </div>

                {/* header start */}
                <div className=" shadow-sm">
                    <div className="card-body">
                        <div className="row g-3">

                            <div className="col-md-2 col-sm-4">
                                <label className="form-label">
                                    Curriculum
                                </label>

                                <select
                                    className="form-select"
                                    name="curriculum"
                                >
                                    <option value="">
                                        Please Select
                                    </option>
                                    <option>SSC</option>
                                    <option>CBSC</option>
                                    <option>ICSE</option>
                                </select>
                            </div>
                            {/* Class Name */}
                            <div className="col-md-2 col-sm-4">
                                <label className="form-label">
                                    Class Name
                                </label>

                                <select
                                    className="form-select"
                                    name="className"
                                >
                                    <option value="">
                                        - Select Class -
                                    </option>
                                    <option>Nursery</option>
                                    <option>LKG</option>
                                    <option>UKG</option>
                                    <option>1st Class</option>
                                    <option>2nd Class</option>
                                    <option>3rd Class</option>
                                    <option>4th Class</option>
                                    <option>5th Class</option>
                                    <option>6th Class</option>
                                    <option>7th Class</option>
                                    <option>8th Class</option>
                                    <option>9th Class</option>
                                    <option>10th Class</option>
                                </select>
                            </div>

                            {/* Section Name */}
                            <div className="col-md-2 col-sm-4">
                                <label className="form-label">
                                    Section Name
                                </label>

                                <select
                                    className="form-select"
                                    name="section"
                                >
                                    <option value="">
                                        - Select Section -
                                    </option>
                                    <option>A</option>
                                    <option>B</option>
                                    <option>C</option>
                                    <option>D</option>
                                    <option>E</option>
                                </select>
                            </div>

                            {/* Leave Status */}
                            <div className="col-md-2 col-sm-4">
                                <label className="form-label">
                                    Leave Status
                                </label>

                                <select
                                    className="form-select"
                                    name="leaveStatus"
                                >
                                    <option value="">
                                        Please Select
                                    </option>
                                    <option>Pending</option>
                                    <option>Approved</option>
                                    <option>Rejected</option>
                                </select>
                            </div>

                            {/* From Date */}
                            <div className="col-md-2 col-sm-4">
                                <label className="form-label">
                                    From Date
                                </label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="fromDate"
                                />
                            </div>

                            {/* To Date */}
                            <div className="col-md-2 col-sm-4">
                                <label className="form-label">
                                    To Date
                                </label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="toDate"
                                />
                            </div>

                            {/* Buttons */}
                            <div className="col-12">
                                <div className="d-flex gap-2 mt-2">
                                    <button
                                        type="button"
                                        className="btn btn-info text-white"
                                    >
                                        <i className="bi bi-search me-1"></i>
                                        Search
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                    >
                                        <i className="bi bi-arrow-clockwise me-1"></i>
                                        Reset Search
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* header end */}

                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Curriculum</th>
                                    <th>Student Name</th>
                                    <th>Class</th>
                                    <th>Section</th>
                                    <th>Roll No</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Reason</th>
                                    <th>Status</th>
                                    <th>Added Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {studentLeaveData.map((row, i) => (
                                    <tr key={row.id}>
                                        <td>{i + 1}</td>
                                        <td>{row.curriculum}</td>
                                        <td>{row.studentName}</td>
                                        <td>{row.className}</td>
                                        <td>{row.section}</td>
                                        <td>{row.rollNumber}</td>
                                        <td>{row.fromDate}</td>
                                        <td>{row.toDate}</td>
                                        <td>{row.reason}</td>
                                        <td>{row.status}</td>
                                        <td>{row.addedDate}</td>

                                        <td>
                                            <button
                                                className="btn btn-success btn-sm me-2"
                                                onClick={() => handleStudentEdit(row)}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </button>

                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() =>
                                                    handleStudentDelete(row.id)
                                                }
                                            >
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    
                    {/* Footer */}
                        <div className="d-flex justify-content-between align-items-center mt-2">
                            <div>
                                <button className="btn btn-info text-white">
                                    Export to Excel
                                </button>
                            </div>

                            <div>
                                Showing 1 to {studentLeaveData.length} of{" "}
                                {studentLeaveData.length} entries
                            </div>

                            <div>
                                <button className="btn btn-light border me-1">
                                    <i className="bi bi-chevron-double-left"></i>
                                </button>

                                <button className="btn btn-info text-white me-1">
                                    1
                                </button>

                                <button className="btn btn-light border">
                                    <i className="bi bi-chevron-double-right"></i>
                                </button>
                            </div>
                        </div>

                </div>
            </div>

            <Modal
                show={showStudentModal}
                onClose={() => setShowStudentModal(false)}
                title={studentEditId ? "Edit Student Leave" : "Add Student Leave"}
                size="lg"
            >
                <form onSubmit={handleStudentLeaveSubmit}>
                    <div className="row">

                        <div className="col-md-6 mb-3">
                            <label>Student Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="studentName"
                                value={studentLeaveForm.studentName}
                                onChange={handleStudentLeaveChange}
                                required
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Class</label>
                            <input
                                type="text"
                                className="form-control"
                                name="className"
                                value={studentLeaveForm.className}
                                onChange={handleStudentLeaveChange}
                                required
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Section</label>
                            <input
                                type="text"
                                className="form-control"
                                name="section"
                                value={studentLeaveForm.section}
                                onChange={handleStudentLeaveChange}
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Roll Number</label>
                            <input
                                type="text"
                                className="form-control"
                                name="rollNumber"
                                value={studentLeaveForm.rollNumber}
                                onChange={handleStudentLeaveChange}
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Leave Status</label>
                            <select
                                className="form-select"
                                name="leaveStatus"
                                value={studentLeaveForm.leaveStatus}
                                onChange={handleStudentLeaveChange}
                                required
                            >
                                <option value="">Select Status</option>
                                <option>Pending</option>
                                <option>Approved</option>
                                <option>Rejected</option>
                            </select>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>From Date</label>
                            <input
                                type="date"
                                className="form-control"
                                name="fromDate"
                                value={studentLeaveForm.fromDate}
                                onChange={handleStudentLeaveChange}
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>To Date</label>
                            <input
                                type="date"
                                className="form-control"
                                name="toDate"
                                value={studentLeaveForm.toDate}
                                onChange={handleStudentLeaveChange}
                                required
                            />
                        </div>

                        <div className="col-md-12 mb-3">
                            <label>Reason</label>
                            <textarea
                                className="form-control"
                                rows="4"
                                name="reason"
                                value={studentLeaveForm.reason}
                                onChange={handleStudentLeaveChange}
                            />
                        </div>

                        <div className="col-md-12">
                            <button
                                type="submit"
                                className="btn btn-primary me-2"
                            >
                                {studentEditId ? "Update Leave" : "Add Leave"}
                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setShowStudentModal(false)}
                            >
                                Cancel
                            </button>
                        </div>

                    </div>
                </form>
            </Modal>
        </>
    )
}

export default StudentsLeaveRequests